import React from "react";
import { Chart } from "react-google-charts";
import PropTypes from "prop-types";
import Config from "conFig.js";
const Thiphanvantai = React.memo(function Thiphanvantai(props) {
  const { thangnam } = props;
  const [hangkhong, setHangkhong] = React.useState(0);
  const [duongthuy, setDuongthuy] = React.useState(0);
  const [duongsat, setDuongsat] = React.useState(0);
  const [duongbo, setDuongbo] = React.useState(0);
  const token = localStorage.getItem("token");
  var username = localStorage.getItem("username");
  var obj = {
    method: "GET",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
      Authorization: "Bearer " + token,
    },
  };
  const getvantaihanghoa = () => {
    var thang = String(thangnam.$M + 1).padStart(2, "0") + "/" + thangnam.$y;
    var url =
      Config.backend +
      "/api/DashBoard/dashbieudovthkpt?thang=" +
      thang +
      "&username=" +
      username;
    fetch(url, obj)
      .then((res) => res.json())
      .then((data) => {
        setHangkhong(data[0].hangkhong);
        setDuongthuy(data[0].duongthuy);
        setDuongsat(data[0].duongsat);
        setDuongbo(data[0].duongbo);
      })
      .catch((error) => {
        console.error("Error fetching data: ", error);
      });
  };
  const data = [
    ["Task", "Tỷ lệ"],
    ["Đường hàng không (" + hangkhong + " lượt)", parseInt(hangkhong)],
    ["Đường thủy (" + duongthuy + " lượt)", parseInt(duongthuy)],
    ["Đường sắt (" + duongsat + " lượt)", parseInt(duongsat)],
    ["Đường bộ (" + duongbo + " lượt)", parseInt(duongbo)],
  ];
  React.useEffect(() => {
    getvantaihanghoa();
  }, [thangnam]);
  return (
    <Chart
      chartType="PieChart"
      loader={<div>Loading</div>}
      data={data}
      height="99%"
      options={{
        chartArea: {
          //marginTop: "-30px",
          width: "97%",
          height: "90%",
        },
        animation: {
          startup: true,
          easing: "linear",
          duration: 800,
        },
        backgroundColor: "transparent",
        hAxis: {
          textStyle: {
            color: "#ffffff",
          },
        },
        vAxis: {
          textStyle: {
            color: "#ffffff",
          },
        },
        legend: {
          textStyle: {
            color: "#ffffff",
          },
          position: "left",
        },
        titleTextStyle: {
          color: "#ffffff",
        },
      }}
    />
  );
});

Thiphanvantai.propTypes = {
  thangnam: PropTypes.object,
};
export default Thiphanvantai;
